import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import { ROUTES } from '../../navigation/route-constants'
import CONSTANTS from '../movielist-constants'
import LOCALE from '../MovieListLocale'
import { isInsideShowPeriod } from '../shared'
import MovieInfo from '../../movie/MovieInfo'
import Showtime from '../../showtime/Showtime'
import Poster from '../../movie/Poster'
import ShowtimeTypeList from '../../showtime/ShowtimeTypeList'

export default class AllMoviesListItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            maxDateCount: 2,
            showMovieInfo: false,
            screenWidth: document.querySelector('.programv2').clientWidth

        }
        this.movieClicked = this.movieClicked.bind(this);
        this.handleWindowResize = this.handleWindowResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleWindowResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowResize);
    }

    handleWindowResize = _.debounce(() => {

        this.setState({ screenWidth: this.screenWidth() });
    })

    screenWidth() {
        const schedule = document.querySelector('.programv2');

        return schedule.clientWidth;
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.showMovieInfo != this.state.showMovieInfo) {
            const { appHeightChanged } = this.props;
            setTimeout(() => { appHeightChanged() }, 500); //Workaround for the duration it takes the DOM to rerender with the expanded element so we get the right height...
        }
    }

    movieClicked(e) {
        const { showMovieInfo } = this.state;
        const { columns, movieClicked } = this.props;
        const dataset = e.target.dataset;
        if (e.target.tagName != 'A') e.preventDefault();

        if (columns == CONSTANTS.columns.one && dataset.toggleMovieInfo) {
            if (showMovieInfo == false) this.setState({ showMovieInfo: true });
            else this.setState({ showMovieInfo: false });
        } else {
            const movieId = e.currentTarget.id || dataset.movieId;
            if (e.target.tagName == 'IMG' || e.target.tagName == 'H1' || e.target.tagName == 'INPUT' || _.includes(e.target.classList, 'poster-banner'))
                movieClicked(movieId);
        }
    }

    showtimeTypes = [];
    generateShowtimesPerDate(showtimesByDate) {
        const { maxDateCount } = this.state;
        const { showLocationOnShowtime, showtimeClicked, columns, showAsBase, showExpired } = this.props;
        const showtimesPerDate = [];
        let counter = 0;
       
        _.forOwn(showtimesByDate, (showtimes, dateKey) => {
         
            if (counter < maxDateCount) {
                showtimesPerDate.push(<div key={dateKey} className="showtimes" style={{ width: showLocationOnShowtime ? " " : this.state.screenWidth < 431 ? '100%' : '50%' }}>
                    <div className="date" >{_.capitalize(dateKey)}</div>

                    {_.map(showtimes, (showtime) => {
                        if (showtime.type && !_.find(this.showtimeTypes, showtime.type)) this.showtimeTypes.push(showtime.type);

                        const dateTime = moment(showtime.dateTime);
                        let text = columns != CONSTANTS.columns.one && showLocationOnShowtime ? `${dateTime.format('LT')} ${showtime.locationName}` : dateTime.format('LT')
                        text = columns == CONSTANTS.columns.five && showLocationOnShowtime ? <div>{dateTime.format('LT')} <span className='loc'>{showtime.locationName}</span> </div> : dateTime.format('LT')

                        return <div key={showtime.id}>
                           {/* {columns == CONSTANTS.columns.one || showLocationOnShowtime ? <div className="location">{showtime.locationName}</div> : ''}*/}
                            <div className='showtimes_location' style={{} }>
                               <Showtime key={showtime.id}
                                showtime={showtime}
                                text={text}
                                withLocation={columns != CONSTANTS.columns.one && showLocationOnShowtime}
                                showtimeClicked={showtimeClicked}
                                showExpired={showExpired}
                                />
                            </div>
                            {isInsideShowPeriod && columns == CONSTANTS.columns.one ? <div className="type">
                                <div>{showtime.type ? showtime.type.name : ''} {showAsBase ? showtime.movieBaseShowName : null}</div>
                            </div> : null}
                            {columns == CONSTANTS.columns.one ? <div className="info">{showtime.info}</div> : null}
                        </div>
                    })}
                </div>);
                counter++;
            } else return false;
        })

        return showtimesPerDate;
    }

    render() {
        const { maxDateCount, showMovieInfo } = this.state;
        const { movie, rowClasses, appLocale, showAsBase, columns, organizerIds, filterIds, showLocationOnShowtime } = this.props;
       
        const poster = movie.posters ?
            <a className="poster-container" href={`${window.location.origin}${ROUTES.MOVIE}/${movie.id}?org=${organizerIds}`}>
                <Poster movie={movie} /></a> : null;

        const movieNameLocale = movie.names ? (movie.names[appLocale] ? movie.names[appLocale] : movie.names['da']) : movie.name;

        const showtimesByDate = _.groupBy(movie.validShowtimes, (showtime) => {
            return showLocationOnShowtime ? moment(showtime.dateTime).format('dddd D/M') :  moment(showtime.dateTime).format('ddd D/M');
        });
        const showtimesPerDate = this.generateShowtimesPerDate(showtimesByDate);

        const moreButton = columns !== CONSTANTS.columns.one && _.keys(showtimesByDate).length > maxDateCount ?
            <div style={{
                border: _.keys(showtimesByDate).length > maxDateCount ? '1px solid grey' : '',
                marginBottom: _.keys(showtimesByDate).length > maxDateCount ? '40px' : '-40px;',
                marginTop: _.keys(showtimesByDate).length > maxDateCount ? '10px' : '0px',
                height: _.keys(showtimesByDate).length > maxDateCount ? '42px' : '0px',
                display: _.keys(showtimesByDate).length > maxDateCount ? 'flex' : '',
                justifyContent: _.keys(showtimesByDate).length > maxDateCount ? 'center' : '',
                
            }}
                className="read-more">
                <input type="button" className="more-showtimes" data-movie-id={movie.id} value={LOCALE[appLocale].moreShowtime} />
                <span style={{display:'block',marginTop:'11px'} }><svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.86133 3.11133L8.41688 8.66688L2.86133 14.2224" stroke="white" stroke-width="1.11111" stroke-linecap="round" />
                </svg>
</span>
            </div> : <div className="read-more"></div>;

        return (
            <div className={rowClasses} id={movie.id} onClick={this.movieClicked} >
                {poster}

                <div className="movie-info ">
                  
                    <a href={`${window.location.origin}${ROUTES.MOVIE}/${movie.id}?org=${organizerIds}`}>
                        {window.location.pathname === '/program-og-fremtidige-filmv2' || window.location.pathname === '/alle-filmv2' ?
                            <div style={{ fontFamily: 'PP Neue Montreal', marginBottom: '20px' }}>
                                <h1 ref={this.titleRef} style={{ height: '55px' }}>{movieNameLocale.split('-')[1] && movie.baseId > 0 ? movieNameLocale.split('-')[0] : movieNameLocale} </h1>
                                <p className='otherVersion' style={{}}>{movie.baseId > 0 && movieNameLocale.split('-')[1] ? movieNameLocale.split('-').pop() : ''}</p>
                            </div>

                            : <h1 style={{ height: 'auto' }} ref={this.titleRef}>{showAsBase ? movie.name : movieNameLocale}</h1>
                        }
                       {/* <h1 ref={this.titleRef}>{showAsBase ? movie.name : movieNameLocale}1</h1>*/}
                    </a>
                    <div style={{ display: showLocationOnShowtime || this.state.screenWidth < 431 ? 'block':'' }} className="flex-container">{showtimesPerDate}</div>
                   
                   

                    {columns === CONSTANTS.columns.one ? <div className="read-more" style={{} }>
                        <input type="button" className="more-showtimes" data-toggle-movie-info={true} value={LOCALE[appLocale].movieInfo} />
                        <input type="button" className="more-showtimes" data-movie-id={movie.id} value={LOCALE[appLocale].allShowtimes} />

                        {columns === CONSTANTS.columns.one ? <MovieInfo addClass={showMovieInfo ? 'slide-down' : 'slide-up'} movie={movie} showTitle={false} appLocale={appLocale} /> : null}
                    </div> : null}
                    {moreButton}
                    {(!filterIds || filterIds.length > 1) && this.showtimeTypes.length > 0 ? <ShowtimeTypeList types={this.showtimeTypes} includeName={true} /> : null}
                    

                </div>
            </div>
        )
    }
}